import { usePersistedState } from './usePersistedState';

const KEY = 'itow.preferences.timezone';

/**
 * User-selected IANA timezone (e.g. `"America/Chicago"`). Empty string =
 * browser default (the user has not opted into a fixed zone).
 *
 * Backed by `usePersistedState` (slice 525/544) so a change in PreferencesPage
 * propagates to all consumers in the same tab via the slice 544 broadcast.
 */
export function useTimezone(): [string, (next: string) => void] {
  return usePersistedState<string>(
    KEY,
    '',
    (v) => v,
    (s) => s,
  );
}

/**
 * Read the stored timezone synchronously without subscribing to changes.
 * For non-React callers (e.g. `formatDate` callers in computed memos that
 * already re-render via other deps).
 */
export function getTimezone(): string {
  try {
    return localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}
